import { render } from "./RowTyreDetail.vue?vue&type=template&id=4b912bbb"
import script from "./RowTyreDetail.vue?vue&type=script&lang=js"
export * from "./RowTyreDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__